// Feature kill-switches. Keep false in production until the feature is fully
// built and rehearsed on staging. Flip to true (then migrate + deploy) to enable.

// Phase 6 — Pontoon (free side-game linked to a Knockout). Env-driven so it can
// be enabled on staging (VITE_PONTOON_ENABLED=true) while prod stays off, matching
// the VITE_PAYMENTS_ENABLED pattern. Unset/anything-but-"true" => off: no Pontoon
// can be created, the play/results page is unreachable, all paths stay dormant.
export const PONTOON_ENABLED = import.meta.env.VITE_PONTOON_ENABLED === 'true';
